/* assets/littleg-kid-constellation.js — LITTLEG-FRIEND-CONSTELLATION-06
 *
 * Friend Map local media runtime for privacy-safe social constellations.
 *
 * PRIVACY CONTRACT:
 * - source authority is LittleGFamilyData.socialGraph only
 * - only private, explicitly confirmed friend rows are eligible
 * - exported media uses anonymous ordinal stars and non-private deterministic layout only
 * - lat/lng/address/placeLabel/estate/search results are never read into the export model
 * - no token, deep link, upload, fetch, XHR, WebSocket or public friend payload
 * - shared URL is the generic Friend Map entry with source=friend_share only
 */
(function (window, document) {
  'use strict';

  var ROOT = '[data-littleg-kid-map]';
  var CONFIG = document.querySelector('[data-littleg-kid-map-config]');
  var PUBLIC_ENTRY_PATH = CONFIG
    ? CONFIG.getAttribute('data-constellation-public-entry')
    : '/pages/littleg-map?source=friend_share';
  var PUBLIC_ENTRY = new URL(
    PUBLIC_ENTRY_PATH || '/pages/littleg-map?source=friend_share',
    window.location.origin
  ).toString();
var PNG_SIZE = 1080;
  var DEFAULT_TEMPLATE = 'story';
  var TEMPLATES = Object.freeze({
    portrait: Object.freeze({ id: 'portrait', width: 1080, height: 1350, layout: 'centered' }),
    story: Object.freeze({ id: 'story', width: 1080, height: 1920, layout: 'centered' }),
    square: Object.freeze({ id: 'square', width: 1080, height: 1080, layout: 'centered' }),
    xiaohongshu: Object.freeze({ id: 'xiaohongshu', width: 1080, height: 1440, layout: 'centered' }),
    landscape: Object.freeze({ id: 'landscape', width: 1200, height: 628, layout: 'editorial' })
  });
  var VERSION = '1.8.14';

  var QR_CANVAS_CACHE = Object.create(null);
var SLOGANS_ZH = [
    { id: 'city-star-01', text: '今天，又點亮了城市的一小角。' },
    { id: 'city-star-02', text: '我的城市，又多了一顆星。' },
    { id: 'city-star-03', text: '走過的地方，慢慢變成我的星空。' },
    { id: 'city-star-04', text: '城市很大，我的星座正在長大。' },
    { id: 'city-star-05', text: '一顆星，一個小小城市故事。' },
    { id: 'city-star-06', text: '今天的城市探索，收藏完成。' }
  ];

  var SLOGANS_EN = [
    { id: 'city-star-01', text: 'Another little corner of the city, lit up.' },
    { id: 'city-star-02', text: 'My city has one more star today.' },
    { id: 'city-star-03', text: 'Little places become my constellation.' },
    { id: 'city-star-04', text: 'My city constellation keeps growing.' },
    { id: 'city-star-05', text: 'One star, one little city story.' },
    { id: 'city-star-06', text: 'Today’s city adventure: collected.' }
  ];

  function q(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function qa(root, selector) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(selector)) : [];
  }

  function clean(value, max) {
    return String(value == null ? '' : value)
      .replace(/[\u0000-\u001f\u007f]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, max || 120);
  }

  function friendStarLabel(count) {
    return Number(count) === 1 ? 'friend star' : 'friend stars';
  }

 function socialGraph() {
    var familyData = window.LittleGFamilyData;
    var graph = familyData && familyData.socialGraph;
    return graph && typeof graph.listPlaces === 'function' ? graph : null;
  }

  function isChinese() {
    return /^zh\b/i.test(document.documentElement.lang || '');
  }

  function hash(value) {
    var source = String(value || '');
    var h = 2166136261;
    for (var i = 0; i < source.length; i += 1) {
      h ^= source.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  function readShareSafeFriends() {
    var graph = socialGraph();
    var rows = graph ? graph.listPlaces() : [];
    if (!Array.isArray(rows)) return [];

    var eligible = rows.filter(function (row) {
      if (!row || typeof row !== 'object') return false;
      var type = row.type || row.kind;
      return type === 'friend'
        && row.visibility === 'family_private'
        && row.privacyConfirmed === true
        && row.parentConfirmed === true
        && row.approvalStatus === 'approved';
    }).slice(0, 24);

    var count = eligible.length;

    return eligible.map(function (_row, index) {
      var ordinal = index + 1;
      return {
        key: 'anonymous-star-' + ordinal,
        seed: hash('anonymous-star-v1|' + count + '|' + ordinal)
      };
    });
  }

  function nextArtifactSeed(root) {
    root.__kidConstellationVariantCounter =
      Number(root.__kidConstellationVariantCounter || 0) + 1;

    var randomPart = 0;

    try {
      if (
        window.crypto &&
        typeof window.crypto.getRandomValues === 'function'
      ) {
        var values = new Uint32Array(1);
        window.crypto.getRandomValues(values);
        randomPart = Number(values[0]) || 0;
      }
    } catch (_) {}

    return hash(
      'fun-share-v1|'
      + Date.now()
      + '|'
      + root.__kidConstellationVariantCounter
      + '|'
      + randomPart
    );
  }

  function sloganFor(seed) {
    var pool = isChinese()
      ? SLOGANS_ZH
      : SLOGANS_EN;

    return pool[
      Math.abs(Number(seed) || 0) %
      pool.length
    ];
  }

 function publicArea(root) {
    var selection = q(root, '[data-gproperty-map-selection]');
    var selectedName = q(selection, '[data-gproperty-map-selected-name]');
    var raw = clean(selectedName && selectedName.textContent, 64);
    var requested = raw.split(/\s+·\s+/)[0].toLowerCase();

    // Only coarse public regions may enter an anonymous image. Shared search
    // also accepts addresses and raw coordinates; never copy those labels.
    var regions = {
      '香港': ['香港', 'Hong Kong'],
      'hong kong': ['香港', 'Hong Kong'],
      '香港島': ['香港島', 'Hong Kong Island'],
      'hong kong island': ['香港島', 'Hong Kong Island'],
      '九龍': ['九龍', 'Kowloon'],
      'kowloon': ['九龍', 'Kowloon'],
      '新界': ['新界', 'New Territories'],
      'new territories': ['新界', 'New Territories'],
      '大嶼山': ['大嶼山', 'Lantau Island'],
      'lantau island': ['大嶼山', 'Lantau Island'],
      '深圳': ['深圳', 'Shenzhen'],
      'shenzhen': ['深圳', 'Shenzhen'],
      '東莞': ['東莞', 'Dongguan'],
      '东莞': ['東莞', 'Dongguan'],
      'dongguan': ['東莞', 'Dongguan']
    };
    var approved = Object.prototype.hasOwnProperty.call(regions, requested)
      ? regions[requested]
      : null;
    if (selection && !selection.hidden && approved) {
      return {
        label: approved[isChinese() ? 0 : 1],
        source: 'public-place'
      };
    }

    return {
      label: isChinese() ? '香港' : 'Hong Kong',
      source: 'public-city-default'
    };
  }
  function templateFor(templateId) {
    return TEMPLATES[templateId] || TEMPLATES[DEFAULT_TEMPLATE];
  }

  function templateGeometry(model, width, height) {
    var template = templateFor(model && model.template);
    var landscape = template.layout === 'editorial';
    var minSide = Math.min(width, height);
    var scale = landscape
      ? width / 1200
      : width / PNG_SIZE;

    return {
      template: template,
      landscape: landscape,
      minSide: minSide,
      scale: scale,
      cx: landscape ? width * 0.70 : width / 2,
      cy: landscape
        ? height * 0.52
        : (
            template.id === 'story'
              ? height * 0.42
              : (
                  template.id === 'square'
                    ? height * 0.48
                    : height * 0.44
                )
          )
    };
  }

  function applyTemplate(modal, canvas, model, templateId) {
    var template = templateFor(templateId || (model && model.template));
    if (!canvas || !model) return template;

    model.template = template.id;
    canvas.width = template.width;
    canvas.height = template.height;

    if (modal) {
      modal.setAttribute('data-kid-share-artifact-template', template.id);
      modal.setAttribute('data-kid-share-template-width', String(template.width));
      modal.setAttribute('data-kid-share-template-height', String(template.height));
      modal.setAttribute('data-kid-share-template-layout', template.layout);

      var preview = q(modal, '.kid-constellation-preview');
      if (preview) {
        preview.style.setProperty(
          '--kid-constellation-preview-aspect',
          template.width + ' / ' + template.height
        );
      }
    }

    return template;
  }

  function shareModel(root) {
    var friends = readShareSafeFriends();
    var variantSeed = nextArtifactSeed(root);
    var slogan = sloganFor(variantSeed);
    var area = publicArea(root);

    return {
      version: 2,
      count: friends.length,
      stars: friends,
      sloganId: slogan.id,
      slogan: slogan.text,
      area: area.label,
      areaSource: area.source,
      dateLabel: isChinese() ? '今日' : 'Today',
      publicEntry: genericEntry(root),
      variantSeed: variantSeed,
      template: DEFAULT_TEMPLATE
    };
  }

  function layoutStars(model, width, height) {
    var geometry = templateGeometry(model, width, height);
    var cx = geometry.cx;
    var cy = geometry.cy;
    var minSide = geometry.minSide;
    var inner = minSide * 0.20;
    var outer = minSide * 0.31;
    var variantSeed = Number(model.variantSeed) || 0;
    var stars = model.stars.map(function (star, index) {
      return {
        key: star.key,
        seed: hash(
          String(star.seed)
          + '|'
          + variantSeed
          + '|'
          + index
        )
      };
    }).sort(function (a, b) { return a.seed - b.seed; });

    return stars.map(function (star, index) {
      var count = Math.max(1, stars.length);
      var baseAngle = (index / count) * Math.PI * 2 - Math.PI / 2;
      var angleJitter = (((star.seed >>> 4) % 41) - 20) * (Math.PI / 180);
      var radiusUnit = ((star.seed >>> 11) % 1000) / 999;
      var radius = inner + (outer - inner) * radiusUnit;
      var angle = baseAngle + angleJitter;
      return {
        key: star.key,
        seed: star.seed,
        x: cx + Math.cos(angle) * radius,
        y: cy + Math.sin(angle) * radius,
        radius: minSide * (0.009 + ((star.seed >>> 20) % 5) * 0.0015),
        paletteIndex: 6 + (star.seed % 6)
      };
    });
  }

 function roundedRect(ctx, x, y, width, height, radius) {
    var r = Math.min(radius, width / 2, height / 2);
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + width, y, x + width, y + height, r);
    ctx.arcTo(x + width, y + height, x, y + height, r);
    ctx.arcTo(x, y + height, x, y, r);
    ctx.arcTo(x, y, x + width, y, r);
    ctx.closePath();
  }

  function drawStar(ctx, x, y, outerRadius, innerRadius, fill) {
    ctx.save();
    ctx.translate(x, y);
    ctx.beginPath();

    for (var point = 0; point < 10; point += 1) {
      var angle = -Math.PI / 2 + point * Math.PI / 5;
      var radius = point % 2 === 0 ? outerRadius : innerRadius;
      var px = Math.cos(angle) * radius;
      var py = Math.sin(angle) * radius;

      if (point === 0) ctx.moveTo(px, py);
      else ctx.lineTo(px, py);
    }

    ctx.closePath();
    ctx.fillStyle = fill;
    ctx.fill();
    ctx.restore();
  }

  function qrCanvasFor(text, size) {
    var value = clean(text, 320);
    var dimension = Math.max(96, Math.round(Number(size) || 160));
    if (!value || typeof window.QRCode !== 'function') return null;

    var cacheKey = dimension + '|' + value;
    if (QR_CANVAS_CACHE[cacheKey]) return QR_CANVAS_CACHE[cacheKey];

    var host = document.createElement('div');
    host.style.position = 'fixed';
    host.style.left = '-9999px';
    host.style.top = '-9999px';
    host.setAttribute('aria-hidden', 'true');
    document.body.appendChild(host);

    try {
      new window.QRCode(host, {
        text: value,
        width: dimension,
        height: dimension
      });

      var source = host.querySelector('canvas');
      if (!source) return null;

      var copy = document.createElement('canvas');
      copy.width = dimension;
      copy.height = dimension;
      copy.getContext('2d').drawImage(source, 0, 0, dimension, dimension);
      QR_CANVAS_CACHE[cacheKey] = copy;
      return copy;
    } catch (_) {
      return null;
    } finally {
      host.remove();
    }
  }

  function drawPublicEntryQr(ctx, model, geometry, width, height) {
    var scale = geometry.scale;
    var qr = qrCanvasFor(model && model.publicEntry, 176 * scale);
    if (!qr) return false;

    var qrSize = 126 * scale;
    var padding = 12 * scale;
    var labelHeight = 30 * scale;
    var boxW = qrSize + padding * 2;
    var boxH = qrSize + padding * 2 + labelHeight;
    var boxX = geometry.landscape
      ? width - boxW - 44 * scale
      : width - boxW - 48 * scale;
    var boxY = height - boxH - 38 * scale;

    ctx.save();
    ctx.fillStyle = 'rgba(255,255,255,0.94)';
    roundedRect(ctx, boxX, boxY, boxW, boxH, 16 * scale);
    ctx.fill();

    ctx.drawImage(
      qr,
      boxX + padding,
      boxY + padding,
      qrSize,
      qrSize
    );

    ctx.textAlign = 'center';
    ctx.fillStyle = '#0f172a';
    ctx.font = '800 ' + Math.max(11, Math.round(13 * scale))
      + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';
    ctx.fillText(
      isChinese() ? '掃碼打開 LittleG' : 'Scan to open LittleG',
      boxX + boxW / 2,
      boxY + padding + qrSize + 20 * scale,
      boxW - padding * 2
    );
    ctx.restore();
    return true;
  }

  function drawPrivacySafeBadge(ctx, geometry, width, height) {
    var scale = geometry.scale;
    var label = isChinese()
      ? '私隱安全 · 不含精確位置'
      : 'Privacy-safe · No precise location';
    var boxX = geometry.landscape ? 70 * scale : 72 * scale;
    var boxY = height - 78 * scale;
    var boxH = 40 * scale;
    var iconSize = 22 * scale;
    var padX = 14 * scale;

    ctx.save();
    ctx.font = '800 ' + Math.max(11, Math.round(14 * scale))
      + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';
    var textW = ctx.measureText(label).width;
    var boxW = Math.min(
      geometry.landscape ? width * 0.42 : width * 0.62,
      textW + iconSize + padX * 3
    );

    ctx.fillStyle = 'rgba(16,185,129,0.12)';
    ctx.strokeStyle = 'rgba(52,211,153,0.58)';
    ctx.lineWidth = Math.max(1, 1.5 * scale);
    roundedRect(ctx, boxX, boxY, boxW, boxH, 18 * scale);
    ctx.fill();
    ctx.stroke();

    var iconX = boxX + padX + iconSize / 2;
    var iconY = boxY + boxH / 2;
    ctx.beginPath();
    ctx.arc(iconX, iconY, iconSize / 2, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(52,211,153,0.22)';
    ctx.fill();

    ctx.fillStyle = '#6ee7b7';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = '900 ' + Math.max(10, Math.round(13 * scale))
      + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';
    ctx.fillText('✓', iconX, iconY + 0.5 * scale);

    ctx.fillStyle = '#a7f3d0';
    ctx.textAlign = 'left';
    ctx.font = '800 ' + Math.max(11, Math.round(14 * scale))
      + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';
    ctx.fillText(
      label,
      boxX + padX * 2 + iconSize,
      iconY,
      boxW - (padX * 3 + iconSize)
    );
    ctx.restore();
  }

  function renderConstellation(canvas, model, phase) {
    var ctx = canvas.getContext('2d');
    var width = canvas.width;
    var height = canvas.height;
    var geometry = templateGeometry(model, width, height);
    var cx = geometry.cx;
    var cy = geometry.cy;
    var scale = geometry.scale;
    var stars = layoutStars(model, width, height);
    var pulse = 0.5 + 0.5 * Math.sin((phase || 0) * Math.PI * 2);

    var bg = ctx.createRadialGradient(cx, cy * 0.72, 0, cx, cy, Math.max(width, height) * 0.76);
    bg.addColorStop(0, '#1d254a');
    bg.addColorStop(0.52, '#0f142d');
    bg.addColorStop(1, '#070a1a');
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, width, height);

    for (var i = 0; i < 150; i += 1) {
      var seed = hash('decorative-star-' + model.variantSeed + '-' + i);
      var x = seed % width;
      var y = (seed >>> 10) % height;
      var alpha = 0.16 + ((seed >>> 20) % 45) / 100;
      var dot = Math.max(0.7, (1 + (seed % 4) * 0.35) * scale);
      ctx.beginPath();
      ctx.arc(x, y, dot, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,255,255,' + alpha.toFixed(2) + ')';
      ctx.fill();
    }

    ctx.save();
    ctx.strokeStyle = 'rgba(183,206,255,0.18)';
    ctx.lineWidth = Math.max(1, 2 * scale);
    ctx.setLineDash([8 * scale, 15 * scale]);
    stars.forEach(function (star) {
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.lineTo(star.x, star.y);
      ctx.stroke();
    });
    ctx.restore();

    if (stars.length > 1) {
      ctx.save();
      ctx.strokeStyle = 'rgba(168,216,255,0.12)';
      ctx.lineWidth = Math.max(1, 1.5 * scale);
      for (var j = 0; j < stars.length; j += 1) {
        var next = stars[(j + 1) % stars.length];
        ctx.beginPath();
        ctx.moveTo(stars[j].x, stars[j].y);
        ctx.lineTo(next.x, next.y);
        ctx.stroke();
      }
      ctx.restore();
    }

    var centerGlow = ctx.createRadialGradient(cx, cy, 0, cx, cy, 66 * scale);
    centerGlow.addColorStop(0, 'rgba(255,224,102,' + (0.58 + pulse * 0.16).toFixed(2) + ')');
    centerGlow.addColorStop(1, 'rgba(255,224,102,0)');
    ctx.fillStyle = centerGlow;
    ctx.beginPath();
    ctx.arc(cx, cy, 66 * scale, 0, Math.PI * 2);
    ctx.fill();

    drawStar(
      ctx,
      cx,
      cy,
      22 * scale,
      10 * scale,
      '#ffe066'
    );

    ctx.fillStyle = 'rgba(255,255,255,0.95)';
    ctx.font = '800 ' + Math.round(22 * scale) + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText(isChinese() ? '我' : 'ME', cx, cy + 54 * scale);

    stars.forEach(function (star, index) {
      var glowRadius = star.radius * (4.8 + pulse * 1.3 + (index % 3) * 0.25);
      var glow = ctx.createRadialGradient(star.x, star.y, 0, star.x, star.y, glowRadius);
      glow.addColorStop(0, 'rgba(255,224,102,0.64)');
      glow.addColorStop(1, 'rgba(255,224,102,0)');
      ctx.fillStyle = glow;
      ctx.beginPath();
      ctx.arc(star.x, star.y, glowRadius, 0, Math.PI * 2);
      ctx.fill();

      drawStar(
        ctx,
        star.x,
        star.y,
        star.radius * (1.48 + pulse * 0.10),
        star.radius * 0.66,
        index % 2 === 0 ? '#ffe066' : '#ffd45e'
      );
    });

    var cardX = geometry.landscape ? 48 * scale : 58 * scale;
    var cardY = geometry.landscape ? 36 * scale : 52 * scale;
    var cardW = geometry.landscape
      ? width * 0.38
      : width - 116 * scale;
    var cardH = geometry.landscape ? 92 * scale : 112 * scale;
    ctx.fillStyle = 'rgba(255,255,255,0.075)';
    roundedRect(ctx, cardX, cardY, cardW, cardH, 28 * scale);
    ctx.fill();

    ctx.textAlign = 'left';
    ctx.fillStyle = '#ffffff';
    ctx.font = '800 ' + Math.round((geometry.landscape ? 30 : 36) * scale) + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';
    ctx.fillText(
      isChinese() ? '我的星座圖' : 'My Constellation',
      geometry.landscape ? 70 * scale : 88 * scale,
      cardY + (geometry.landscape ? 60 : 64) * scale
    );

    if (!model.count) {
      ctx.textAlign = geometry.landscape ? 'left' : 'center';
      ctx.fillStyle = 'rgba(220,231,255,0.72)';
      ctx.font = '700 ' + Math.round(26 * scale) + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';
      ctx.fillText(
        isChinese() ? '新增朋友後，就能點亮你的星空' : 'Add friends to light up your constellation',
        geometry.landscape ? 70 * scale : cx,
        geometry.landscape ? height * 0.58 : cy + 150 * scale,
        geometry.landscape ? width * 0.38 : width - 160 * scale
      );
    } else if (geometry.landscape) {
      ctx.textAlign = 'left';
      ctx.fillStyle = 'rgba(255,255,255,0.96)';
      ctx.font = '800 ' + Math.round(26 * scale) + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';
      ctx.fillText(model.slogan, 70 * scale, height * 0.50, width * 0.39);

      ctx.fillStyle = 'rgba(220,231,255,0.82)';
      ctx.font = '700 ' + Math.round(18 * scale) + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';
      ctx.fillText(
        model.area
        + ' · '
        + model.dateLabel
        + ' · '
        + model.count
        + (isChinese() ? ' 顆好友星' : ' ' + friendStarLabel(model.count)),
        70 * scale,
        height * 0.58,
        width * 0.39
      );
    } else {
      ctx.textAlign = 'left';
      ctx.fillStyle = 'rgba(255,255,255,0.96)';
      ctx.font = '800 ' + Math.round(27 * scale) + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';
      ctx.fillText(
        model.slogan,
        72 * scale,
        height - 166 * scale,
        width - 360 * scale
      );

      ctx.fillStyle = 'rgba(220,231,255,0.82)';
      ctx.font = '700 ' + Math.round(19 * scale) + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';
      ctx.fillText(
        model.area
        + ' · '
        + model.dateLabel
        + ' · '
        + model.count
        + (isChinese() ? ' 顆好友星' : ' ' + friendStarLabel(model.count)),
        72 * scale,
        height - 124 * scale,
        width - 360 * scale
      );
    }

    var hasQr = drawPublicEntryQr(ctx, model, geometry, width, height);
    drawPrivacySafeBadge(ctx, geometry, width, height);
    if (!hasQr) {
      ctx.textAlign = 'right';
      ctx.fillStyle = 'rgba(255,255,255,0.46)';
      ctx.font = '700 ' + Math.round(16 * scale) + 'px -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';
      ctx.fillText('LittleG ✦', width - 64 * scale, height - 58 * scale);
    }
  }
function canvasToBlob(canvas, type) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (blob) resolve(blob);
        else reject(new Error('canvas_export_failed'));
      }, type || 'image/png');
    });
  }

  function downloadBlob(blob, filename) {
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
  }

  function genericEntry(_root) {
    var config = document.querySelector('[data-littleg-kid-map-config]');
    var value = config && clean(config.getAttribute('data-constellation-public-entry'), 200);
    if (!value) return PUBLIC_ENTRY;
    try {
      return new URL(value, window.location.origin).toString();
    } catch (_) {
      return PUBLIC_ENTRY;
    }
  }

  async function writeClipboardText(value) {
    var text = clean(value, 1200);
    if (!text) throw new Error('copy-empty');

    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return text;
    }

    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();

    var copied = false;
    try {
      copied = document.execCommand('copy');
    } finally {
      field.remove();
    }

    if (!copied) throw new Error('copy-failed');
    return text;
  }

  function postCaption(root) {
    var link = genericEntry(root);
    var count = readShareSafeFriends().length;

    return isChinese()
      ? '✨ 我的 LittleG 好友星圖已點亮 ' + count + ' 顆星。\n'
        + '一起看看你的城市星圖：' + link + '\n'
        + '#LittleG #好友星圖 #城市探索'
      : '✨ My LittleG Friends Map has ' + count + ' ' + friendStarLabel(count) + '.\n'
        + 'See your city constellation: ' + link + '\n'
        + '#LittleG #FriendsMap #CityExploration';
  }

  async function shareBlob(root, blob, filename) {
    var file = new File([blob], filename, { type: blob.type });
    var data = {
      title: isChinese() ? 'LittleG 我的星座圖' : 'LittleG My Constellation',
      text: postCaption(root),
      files: [file]
    };

    if (navigator.share && (!navigator.canShare || navigator.canShare({ files: [file] }))) {
      try {
        await navigator.share(data);
        return 'shared';
      } catch (error) {
        if (error && error.name === 'AbortError') return 'cancelled';
      }
    }

    downloadBlob(blob, filename);
    var captionCopied = false;
    try {
      await writeClipboardText(postCaption(root));
      captionCopied = true;
    } catch (_) {}
    return captionCopied ? 'downloaded-caption-copied' : 'downloaded';
  }

  function setBusy(button, busy, textValue) {
    if (!button) return;

    if (busy) {
      if (!button.__kidConstellationActionHtml) {
        button.__kidConstellationActionHtml = button.innerHTML;
      }
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (textValue) button.textContent = textValue;
      return;
    }

    button.disabled = false;
    button.setAttribute('aria-busy', 'false');
    if (button.__kidConstellationActionHtml) {
      button.innerHTML = button.__kidConstellationActionHtml;
      button.__kidConstellationActionHtml = '';
    }
  }

  function notifyKidMap(message, host) {
    var runtime = window.LittleGKidMap;
    if (!runtime || typeof runtime.notify !== 'function') return false;
    return runtime.notify(message, host);
  }

  function setConstellationIntent(open) {
    try {
      var url = new URL(window.location.href);
      if (open) url.searchParams.set('intent', 'constellation');
      else if (url.searchParams.get('intent') === 'constellation') url.searchParams.delete('intent');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (_) {}
  }

  function urlRequestsConstellation() {
    try {
      return new URL(window.location.href).searchParams.get('intent') === 'constellation';
    } catch (_) {
      return false;
    }
  }

  function projectHomeState(root, trigger, count) {
    var state = Number(count) > 0 ? 'ready' : 'empty';
    root.setAttribute('data-kid-constellation-home-state', state);
    if (trigger) {
      trigger.setAttribute('data-kid-constellation-home-state', state);
    }
    return state;
  }

  function projectEmptyState(root, trigger, modal, model) {
    var ready = Number(model && model.count) > 0;
    var empty = q(modal, '[data-kid-constellation-empty]');
    var preview = q(modal, '[data-kid-constellation-preview]');
    var actions = q(modal, '[data-kid-constellation-actions]');
    var progress = q(modal, '[data-kid-constellation-progress]');

    projectHomeState(root, trigger, model && model.count);

    if (empty) empty.hidden = ready;
    if (preview) preview.hidden = !ready;
    if (actions) actions.hidden = !ready;
    if (progress) {
      progress.hidden = !ready;
      if (!ready) progress.textContent = '';
    }

    modal.setAttribute(
      'data-kid-constellation-state',
      ready ? 'ready' : 'empty'
    );

    return ready;
  }

  function bindUi(root) {
    if (!root || root.__kidConstellationUi) return;
    root.__kidConstellationUi = true;

    var trigger = q(root, '[data-kid-constellation-open]');
    var modal = q(root, '[data-kid-constellation-modal]');
    if (!trigger || !modal) return;

    projectHomeState(
      root,
      trigger,
      readShareSafeFriends().length
    );

    function setShareTemplateMenu(open) {
      var menu = q(modal, '[data-kid-share-template-menu]');
      var shareTrigger = q(modal, '[data-kid-share-template-trigger]');
      var expanded = open === true;

      if (menu) menu.hidden = !expanded;
      if (shareTrigger) {
        shareTrigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }

      if (expanded && menu) {
        var firstOption = q(menu, '[data-kid-share-template-option]');
        if (firstOption) {
          window.setTimeout(function () { firstOption.focus(); }, 0);
        }
      }
    }

    function openModal(options) {
      var model = shareModel(root);
      var canvas = q(modal, '[data-kid-constellation-canvas]');
      if (!canvas) return;

      var ready = projectEmptyState(
        root,
        trigger,
        modal,
        model
      );

      if (ready) {
        applyTemplate(modal, canvas, model, DEFAULT_TEMPLATE);
        projectTemplateSelection(modal, DEFAULT_TEMPLATE);
        renderConstellation(canvas, model, 0.18);
      }

      setShareTemplateMenu(false);

      modal.__kidConstellationModel = model;
      modal.setAttribute('data-kid-share-artifact-slogan-id', model.sloganId);
      modal.setAttribute('data-kid-share-artifact-slogan', model.slogan);
      modal.setAttribute('data-kid-share-artifact-area', model.area);
      modal.setAttribute('data-kid-share-artifact-area-source', model.areaSource);
      modal.setAttribute('data-kid-share-artifact-date-label', model.dateLabel);
      modal.setAttribute('data-kid-share-artifact-variant-seed', String(model.variantSeed));
      modal.setAttribute('data-kid-share-template-default', DEFAULT_TEMPLATE);

      if (!options || options.syncUrl !== false) {
        setConstellationIntent(true);
      }

      trigger.setAttribute(
        'aria-expanded',
        'true'
      );

      if (typeof modal.showModal === 'function') {
        if (!modal.open) modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
    }

    function closeModal(options) {
      if (!options || options.syncUrl !== false) {
        setConstellationIntent(false);
      }

      trigger.setAttribute(
        'aria-expanded',
        'false'
      );

      setShareTemplateMenu(false);

      if (typeof modal.close === 'function') {

        if (modal.open) modal.close();
      } else {
        modal.removeAttribute('open');
      }
    }

    trigger.addEventListener('click', function () {
      openModal({ syncUrl: true });
    });

    var close = q(modal, '[data-kid-constellation-close]');
    if (close) {
      close.addEventListener('click', function () {
        closeModal({ syncUrl: true });
      });
    }

    modal.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeModal({ syncUrl: true });
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal({ syncUrl: true });
    });

    var emptyAdd = q(modal, '[data-kid-constellation-empty-add]');
    if (emptyAdd) {
      emptyAdd.addEventListener('click', function () {
        closeModal({ syncUrl: true });

        var runtime = window.LittleGKidMap;
        if (runtime && typeof runtime.openAdd === 'function') {
          window.setTimeout(function () {
            runtime.openAdd('friend');
          }, 0);
          return;
        }

        var addFriend = q(root, '[data-kid-add-kind="friend"]');
        if (addFriend) {
          window.setTimeout(function () {
            addFriend.click();
          }, 0);
        }
      });
    }

    async function runAction(button, action) {
      var model = modal.__kidConstellationModel || shareModel(root);
      var canvas = q(modal, '[data-kid-constellation-canvas]');
      var progress = q(modal, '[data-kid-constellation-progress]');

      try {
        if (!canvas) return;

        setBusy(button, true, isChinese() ? '正在生成圖片…' : 'Rendering image…');

        if (
          action !== 'share-image' &&
          action !== 'save-image'
        ) {
          return;
        }

        var outputTemplate =
          action === 'save-image'
            ? DEFAULT_TEMPLATE
            : model.template;

        applyTemplate(modal, canvas, model, outputTemplate);
        projectTemplateSelection(modal, outputTemplate);
        renderConstellation(canvas, model, 0.18);

        var blob = await canvasToBlob(canvas, 'image/png');
        var filename =
          'littleg-friends-map-'
          + clean(model.template || DEFAULT_TEMPLATE, 24)
          + '.png';

        if (action === 'share-image') {
          setBusy(
            button,
            true,
            isChinese() ? '正在打開分享選單…' : 'Opening share menu…'
          );

          var result = await shareBlob(root, blob, filename);
          var shareMessage =
            result === 'shared'
              ? (isChinese() ? '✓ 已分享' : '✓ Shared')
              : (
                  result === 'downloaded-caption-copied'
                    ? (
                        isChinese()
                          ? '✓ 圖片已儲存，分享文案已複製'
                          : '✓ Image saved. Caption copied'
                      )
                    : (
                        result === 'downloaded'
                          ? (isChinese() ? '✓ 圖片已儲存' : '✓ Image saved')
                          : ''
                      )
                );
          if (progress) progress.textContent = shareMessage;
          if (shareMessage) notifyKidMap(shareMessage, modal);
        } else {
          setBusy(
            button,
            true,
            isChinese() ? '正在儲存圖片…' : 'Saving image…'
          );

          downloadBlob(blob, filename);

          var saveMessage =
            isChinese()
              ? '✓ 圖片已儲存'
              : '✓ Image saved';
          if (progress) progress.textContent = saveMessage;
          notifyKidMap(saveMessage, modal);
        }
      } catch (error) {
        var errorMessage =
          isChinese()
            ? '還沒準備好，再試一次。'
            : 'Not ready yet. Try again.';
        if (progress) progress.textContent = errorMessage;
        notifyKidMap(errorMessage, modal);
      } finally {
        setBusy(button, false);
      }
    }

    qa(modal, '[data-kid-share-template-option]').forEach(function (button) {
      button.addEventListener('click', async function () {
        var templateId = button.getAttribute('data-kid-share-template-option');
        setTemplate(templateId);
        setShareTemplateMenu(false);

        var shareButton = q(
          modal,
          '[data-kid-constellation-action="share-image"]'
        );
        if (shareButton) {
          await runAction(shareButton, 'share-image');
        }
      });
    });

    qa(modal, '[data-kid-constellation-action]').forEach(function (button) {
      button.addEventListener('click', async function () {
        var action = button.getAttribute('data-kid-constellation-action');

        if (action === 'share-image') {
          var menu = q(modal, '[data-kid-share-template-menu]');
          setShareTemplateMenu(!!(menu && menu.hidden));
          return;
        }

        setShareTemplateMenu(false);
        await runAction(button, action);
      });
    });

    if (urlRequestsConstellation()) {
      openModal({ syncUrl: false });
    }
  }

  function projectTemplateSelection(modal, templateId) {
    var picker = q(modal, '[data-kid-share-template-picker]');
    if (picker) {
      picker.setAttribute(
        'data-kid-share-template-selected',
        templateId
      );
    }

    qa(
      modal,
      '[data-kid-share-template-option]'
    ).forEach(function (button) {
      button.setAttribute(
        'aria-pressed',
        button.getAttribute(
          'data-kid-share-template-option'
        ) === templateId
          ? 'true'
          : 'false'
      );
    });
  }

  function setTemplate(templateId) {
    var root = q(document, ROOT);
    var modal = q(root, '[data-kid-constellation-modal]');
    var canvas = q(modal, '[data-kid-constellation-canvas]');
    var model = modal && modal.__kidConstellationModel;

    if (!root || !modal || !canvas || !model) return null;

    var beforeSeed = model.variantSeed;
    var beforeSlogan = model.sloganId;
    var template = applyTemplate(modal, canvas, model, templateId);
    projectTemplateSelection(modal, template.id);
    renderConstellation(canvas, model, 0.18);

    return {
      id: template.id,
      width: canvas.width,
      height: canvas.height,
      layout: template.layout,
      seedPreserved: beforeSeed === model.variantSeed,
      sloganPreserved: beforeSlogan === model.sloganId
    };
  }
function mount() {
    qa(document, ROOT).forEach(function (root) {
      if (root.__kidConstellationMounted === VERSION) return;
      root.__kidConstellationMounted = VERSION;
      bindUi(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', mount);

  window.LittleGKidConstellation = {
    mount: mount,
    version: VERSION,
    privacy: 'anonymous-stars-only',
    socialGraphOwner: 'LittleGFamilyData.socialGraph',
    publicEntry: PUBLIC_ENTRY,
    defaultTemplate: DEFAULT_TEMPLATE,
    templates: TEMPLATES,
    setTemplate: setTemplate
  };
})(window, document);